import { FieldValidatorType } from "@progress/kendo-react-form";

const coordinateRegex = new RegExp(/^((?:[+-]?[0-9]*[.,][0-9]+)|(?:[+-]?[0-9]+))/);

export const coordinateValidator: FieldValidatorType = (value: string) =>
coordinateRegex.test(value) ? "" : "Il campo deve essere una coordinata. Formato 45.35045043";